mutation SetEventYouTubeSpeed($eventId: ID!, $level: String) {
  speed: StreamToolsSetEventYouTubeSpeed(eventId: $eventId, level: $level) {
    eventId
    level
    appDefaultLevel
    effectiveLevel
    liveAllowed
    brakeCapLevel
    updatedAt
  }
}
